/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export { default as FileUploaderBasic } from './file-uploader-basic';

// Styled elements
export { StyledRoot, StyledFileDragAndDrop, StyledContentMessage, StyledContentSeparator, StyledErrorMessage, StyledHiddenInput } from './styled-components';

// Flow
export * from './types';
export type { FileUploaderBasicLocale } from './locale';